globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Public = appCustomerSpace.Controllers.Public || {};

appCustomerSpace.Controllers.Public.WelcomeRemoteAuditsFunnelController = (function (superClass) {

  utils.extend(MainController, superClass);

  function MainController() {
    return MainController.__super__.constructor.apply(this, arguments);
  }

  $.extend(MainController.prototype, {
    init: function() {
      var controller = this;
      controller.$html = $('body.welcome-funnel');
      controller.$generateAuditLoader = controller.$html.find('#generate-audit-loader');
      return MainController.__super__.init.apply(this, arguments);
    },
    start: function() {
      var controller = this;
      var $form = controller.$html.find('form');
      var $input = controller.$html.find('input[name="website_url"]');

      $form.on('ajax:success', function(e, data) {
        if(data.response == 1) {
          window.location.href = data.redirect_url;
        } else {
          $input.addClass('invalid');
          setTimeout(function() {
            $input.removeClass('invalid');
          }, 3000);
        }
      });
    },
    generate_audit: function() {
      var controller = this;
      var stepTimeouts = [];
      var timeOutUrl = controller.$generateAuditLoader.data('timeout-url');
      var generationTimeoutMs = 120000; // 2 minutes

      var guardTimeoutId = setTimeout(function() {
        if (stepTimeouts && stepTimeouts.length) {
          stepTimeouts.forEach(function(id) { clearTimeout(id); });
          stepTimeouts.length = 0;
        }
        globalThis.App.cable.disconnect();
        window.location.href = timeOutUrl;
      }, generationTimeoutMs);

      stepTimeouts.push(guardTimeoutId);

      controller.channelSubscribe(controller.$generateAuditLoader.data('project-uniq-key'), stepTimeouts);
      var steps = [
        "Recherche de votre site internet...",
        "Exploration des pages...",
        "Analyse du contenu...",
        "Analyse de l'indexation...",
        "Analyse de la sécurité...",
        "Analyse de la performance technique...",
        "Analyse de l'expérience utilisateur...",
        "Analyse de l'accessibilité...",
        "Calcul de votre score...",
        "Mise en forme de votre audit...",
        "Préparation de votre interface..."
      ];

      var delaysMs = [1000];
      for (var i = 1; i < steps.length; i++) {
        delaysMs.push(delaysMs[i - 1] + controller.randomDelay(2000, 4000));
      }

      appCustomerSpace.Loader().start({ $container: controller.$generateAuditLoader, options: { style: { backdrop: { background: "#fff" } } } });

      steps.forEach(function(step, index) {
        stepTimeouts.push(setTimeout(function() {
          appCustomerSpace.Loader().set({ $container: controller.$generateAuditLoader, options: { text: step, style: { backdrop: { background: "#fff" } } } });
        }, delaysMs[index]));
      });
    },
    randomDelay: function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    channelSubscribe: function(projectUniqKey, stepTimeouts) {
      var controller = this;

      globalThis.App.cable.subscriptions.create({
        channel: "CustomerSpace::Website::Audit::ReportGenerationChannel",
        project_uniq_key: projectUniqKey
      }, {
        received: function(data) {
          if (stepTimeouts && stepTimeouts.length) {
            stepTimeouts.forEach(function(id) { clearTimeout(id); });
            stepTimeouts.length = 0;
          }
          if (data.action === "report_generation_finished") {
            controller.onChannelReceived(data);
            globalThis.App.cable.disconnect();
          }
        }
      });
    },
    onChannelReceived: function(data) {
      var controller = this;
      var redirectUrl = controller.$generateAuditLoader.data('redirect-url');
      var failedUrl = controller.$generateAuditLoader.data('failed-url');

      if (data.status === "success") {
        window.location.href = redirectUrl;
      } else if (data.status === "failed") {
        window.location.href = failedUrl;
      }
    }
  });

  return MainController;

})(appCustomerSpace.Controllers.Public.MainController);
